import React, { FC, useCallback } from 'react'
import { PartnershipType } from '..'
import FilterPills from './FilterPills'

export const resourceMap: Record<string, string> = {
    'Sustainable Minds': 'Sustainability',
    BIMsmith: 'BIM',
}

export const resourceTypeMap: Record<string, PartnershipType> = {
    'Sustainable Minds': 'Sustainability Resources',
    BIMsmith: 'BIM Resources',
}

const AdvancedResourcesFilter: FC<{
    resources: string[]
    resourcesOptions: string[]
    handleClick: (type: PartnershipType, value: string[]) => void
}> = ({ resources, handleClick, resourcesOptions }) => {
    const handleReourceFilterClick = useCallback(
        (resource: string) => () => {
            if (resources.includes(resource)) {
                handleClick(resourceTypeMap[resource], []) // since it's only one option per resource, set as empty array
                return
            } else {
                handleClick(resourceTypeMap[resource], [resource])
            }
        },
        [resources, handleClick]
    )

    return (
        <>
            {resourcesOptions.map((resource) => (
                <FilterPills
                    data-testid={`listingDialog_resourcesFilters_${resource}`}
                    buttonText={resourceMap[resource]}
                    key={resource}
                    handleClick={handleReourceFilterClick(resource)}
                    isActive={resources.includes(resource)}
                />
            ))}
        </>
    )
}

export default AdvancedResourcesFilter
